import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser'

const msalConfig: Configuration = {
  auth: {
    clientId: 'c821ed34-99dd-473a-9edd-4eba9540f3d0',
    authority: 'https://login.microsoftonline.com/7c4f77bb-bc61-4789-8aca-54aa04ebb634',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (level === LogLevel.Error) console.error(message)
      },
    },
  },
}

export const loginRequest = {
  scopes: ['api://c821ed34-99dd-473a-9edd-4eba9540f3d0/access_as_user'],
}

export const msalInstance = new PublicClientApplication(msalConfig)
